import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const expandButton = this.element.parentElement.querySelectorAll('.membership-overlay button');
        const membershipsLength = this.element.querySelectorAll('.memberships-list__item').length;
        let maxHeight = 608;

        if (membershipsLength <= 4) {
            maxHeight = 308;
        }

        if (this.element.classList.contains('static')) {
            return
        }

        this.element.style.maxHeight = maxHeight + 'px';

        for (const button of expandButton) {
            button.addEventListener('click', () => {
                if (this.element.style.maxHeight.replace('px', '') == maxHeight) {
                    this.element.style.maxHeight = this.element.scrollHeight + 'px';
                    button.parentElement.querySelector('.gradient').classList.add('hidden');
                    button.parentElement.classList.add('active');
                } else {
                    this.element.style.maxHeight = maxHeight + 'px';
                    button.parentElement.querySelector('.gradient').classList.remove('hidden');
                    button.parentElement.classList.remove('active');
                }
            });
        }
    }

    changeHours(el) {
        const parent = el.target.parentNode;
        const wrapper = parent.parentNode;
        const options = parent.querySelectorAll('.time-option');
        const initialHref = wrapper.querySelector('.btn.btn-order').href;

        options.forEach(option => {
            option.classList.remove('active');
        });

        el.target.classList.add('active');

        wrapper.querySelector('.price').innerHTML = el.target.dataset.membershipPrice + ' €';

        const urlWithParameters = new URL(initialHref);

        urlWithParameters.searchParams.set("mid", el.target.dataset.membershipId);
        urlWithParameters.searchParams.set("hr", el.target.dataset.hours);

        wrapper.querySelector('.btn.btn-order').href = urlWithParameters.href;
    }

    toggleCartLoader(el) {
        el.target.classList.add('loading');
    }
}
